module.exports = __webpack_public_path__ + "img/partner10.0f3093e7.png";